import { useTranslation } from 'react-i18next';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

export const DispatchCredentialingButton = ({ onClick = undefined, disabled = false }) => {
  const { t } = useTranslation();
  
  return [
    {
      title: t('placement.profile.credentialing'),
      Icon: FactCheckOutlinedIcon,
      disabled: disabled,
      tooltipProps: {
        tooltipContent: 
          t('placement.credentialingBtn.buttonTooltip'),
        disabled: false,
      },
      onClick: event => {
        onClick?.(event);
      },
    },
  ];
}; 